<div class="container mx-auto">
  <!-- Error Header: Code and Message above the image -->
  <div class="error-header">
    <div class="error-code">404</div>
    <div class="error-message">Oops! Page Not Found</div>
  </div>

  <!-- Illustration / Image -->
  <img src="/assets/images/backgrounds/no-data.png" alt="404 Not Found Illustration" class="error-img" />

  <!-- Description Text below the image -->
  <div class="error-description">
    The page you’re looking for doesn’t exist or has been moved. It might be a
    typo in the URL or an outdated link.
  </div>

  <!-- Home button -->
  <a href="https://udaanhotels.com" class="btn-home">Return to Home</a>
</div>